import { useModal, useProfile } from '@/hooks';
import { useAuthenticated } from '@/hooks/useAuthenticated.hook';
import {
  useCosmosControllerConnectWalletMutation,
  useCosmosControllerAuthenticateMutation,
  useLazyCosmosControllerGetCosmosLoginMessageQuery,
} from '@/store/services/MidleNestApi.service';
import { useNavigate } from 'react-router-dom';

export default function useLeapConnect() {
  const [getMessage] = useLazyCosmosControllerGetCosmosLoginMessageQuery();
  const [walletLogin] = useCosmosControllerAuthenticateMutation();
  const [walletConnect] = useCosmosControllerConnectWalletMutation();

  const { isAuthenticated } = useAuthenticated();
  const { reloadProfile } = useProfile();
  const navigate = useNavigate();
  const { hideModal } = useModal();

  const signArbitraryLeap = async (signer: string, message: string) => {
    const signature = await (window as any).leap?.signArbitrary('cataclysm-1', signer, message);
    return {
      signature: signature?.signature,
      publicKey: signature?.pub_key.value,
    };
  };

  const handleSignMessage = async (signer: string, message: string) => {
    try {
      return await signArbitraryLeap(signer, message);
    } catch (error) {
      console.log({ error });
      return '';
    }
  };

  const handleLeapConnect = async () => {
    const key = await (window as any).leap?.getKey('cataclysm-1');
    if (key) {
      getMessage(key.bech32Address.toLowerCase())
        .unwrap()
        .then(async (nonce) => {
          const signature = await handleSignMessage(key.bech32Address, nonce.message);
          if (!signature || !signature.publicKey || !signature.signature) return; // TODO: display error message
          if (isAuthenticated) {
            walletConnect({
              accountAddress: key.bech32Address,
              message: nonce.message,
              signature: signature.signature,
              signaturePublicKey: signature.publicKey,
            })
              .unwrap()
              .then((res) => {
                // eslint-disable-next-line no-undef
                gtag('event', 'connect-wallet');
                reloadProfile();
                hideModal();
                return navigate('/', {});
              })
              .catch((e) => {
                console.log(e);
              });
          } else {
            walletLogin({
              accountAddress: key.bech32Address,
              message: nonce.message,
              signature: signature.signature,
              signaturePublicKey: signature.publicKey,
            })
              .unwrap()
              .then((res) => {
                // eslint-disable-next-line no-undef
                gtag('event', 'auth-wallet');
                reloadProfile();
                hideModal();
                return navigate('/', {});
              })
              .catch((e) => {
                console.log(e);
              });
          }
        })
        .catch((e) => {
          console.log(e);
        });
    }
  };

  return handleLeapConnect;
}
